module.exports = {
  NOT_OPEN: 'NOT OPEN',
  IN_PROGRESS: 'IN PROGRESS',
  IN_GRADING: 'IN GRADING',
  DONE: 'DONE',
  ARCHIVED: 'ARCHIVED',
}
